import { atom } from 'recoil';

export const issuedCoverablesAndPricesAtom = atom({
    key: 'issuedCoverablesAndPricesAtom',
    default: {}
});
